import React, { useState } from 'react';
import { Typography, Box, Link } from '@mui/material';
import TextInputBox from '../../components/TextInputBox';
import { LOGIN_CHECKSIGNMAIL, LOGIN_LOGIN } from '../../constants';
import ButtonBox from '../../components/ButtonBox';
import '../../style/Login.css';

interface SignupProps {
    setLoginPage: React.Dispatch<React.SetStateAction<string>>;
}

const Signup: React.FC<SignupProps> = ({ setLoginPage }) => {

    const handleChange = (field: string) => (e: React.ChangeEvent<HTMLInputElement>) => {
        setFormValues((prevValues) => ({ ...prevValues, [field]: e.target.value }));
    };

    const [formValues, setFormValues] = useState({
        username: '',
        email: '',
        password: '',
        confirmPassword: '',
    });

    const handleSignup = () => {
        console.log('User signed up with:', formValues);
        setLoginPage(LOGIN_CHECKSIGNMAIL);
    };

    return (
        <>
            <Typography className='login_typography_title'>
                Sign up
            </Typography>

            <TextInputBox
                label="User name"
                value={formValues.username}
                onChange={handleChange('username')}
                placeholder="Ben"
            />

            <TextInputBox
                label="Email"
                value={formValues.email}
                onChange={handleChange('email')}
                placeholder="Please enter your email"
                type="email"
            />

            <TextInputBox
                label="Password"
                value={formValues.password}
                onChange={handleChange('password')}
                placeholder="At least 8 characters"
                type="password"
            />

            <TextInputBox
                label="Confirm password"
                value={formValues.confirmPassword}
                onChange={handleChange('confirmPassword')}
                type="password"
            />

            <ButtonBox
                text="Send me mail"
                onClick={handleSignup}
            />

            <Box display="flex" justifyContent="center" mt={2}>
                <Typography className='login_typography_content'>
                    Already have an acoount?{' '}
                    <Link
                        href="#"
                        color="primary"
                        underline="none"
                        onClick={() => setLoginPage(LOGIN_LOGIN)}
                    >
                        Log in
                    </Link>
                </Typography>
            </Box>
        </>
    );
};

export default Signup;
